import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Baby, Scissors, Activity, ShieldCheck, Calendar as CalIcon, Clock, CheckCircle, ChevronRight, User, Phone, Send, Loader2, AlertCircle, MessageSquare, Video, Building2 } from 'lucide-react';
import { collection, addDoc, serverTimestamp, doc, getDoc } from 'firebase/firestore'; // getDoc eklendi
import { db } from '../firebase/firebase-config';
import Navbar from '../Navbar/Navbar';
import FooterSection from '../FooterSection/FooterSection';
import toast, { Toaster } from 'react-hot-toast';
import './AppointmentPage.css';

const AppointmentPage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const [timeSlots, setTimeSlots] = useState([]); // Dinamik saatler burada tutulacak
  
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    date: '',
    time: '',
    note: '',
    type: 'Yüz Yüze'
  });

  const today = new Date();
  const minDate = today.toISOString().split('T')[0];
  const oneMonthLater = new Date();
  oneMonthLater.setMonth(today.getMonth() + 1);
  const maxDate = oneMonthLater.toISOString().split('T')[0];

  // 1. AYARLARI ÇEK VE SAATLERİ OLUŞTUR
  useEffect(() => {
    const fetchSettingsAndGenerateSlots = async () => {
      try {
        const docRef = doc(db, "settings", "appointmentSettings");
        const docSnap = await getDoc(docRef);
        
        if (docSnap.exists()) {
          const { workingStart, workingEnd, slotDuration } = docSnap.data();
          
          // Saat oluşturma fonksiyonu
          const slots = [];
          let current = new Date(`2026-01-01T${workingStart}:00`);
          const stop = new Date(`2026-01-01T${workingEnd}:00`);

          while (current < stop) {
            slots.push(current.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' }));
            current.setMinutes(current.getMinutes() + slotDuration);
          }
          setTimeSlots(slots);
        } else {
          // Eğer ayar yoksa varsayılan saatleri koyalım
          setTimeSlots(["09:00", "10:00", "11:00", "14:00", "15:00"]);
        }
      } catch (error) {
        console.error("Ayarlar yüklenemedi:", error);
      }
    };

    window.scrollTo(0, 0);
    fetchSettingsAndGenerateSlots();
  }, []);

  const validatePhone = (phone) => {
    const re = /^(05|5)\d{9}$/;
    return re.test(phone);
  };

  const handleDateChange = (e) => {
    const selected = e.target.value;
    if (selected < minDate || selected > maxDate) {
      toast.error("Sadece önümüzdeki 30 gün için randevu alabilirsiniz!");
      setFormData({ ...formData, date: '' });
    } else {
      setFormData({ ...formData, date: selected });
    }
  };

  const handleFinalSubmit = async (e) => {
    e.preventDefault();
    if (!validatePhone(formData.phone)) {
      toast.error("Lütfen geçerli bir numara giriniz!");
      return;
    }

    setIsUploading(true);
    const loadingToast = toast.loading('Kaydediliyor...');

    try {
      await addDoc(collection(db, "appointments"), {
        ...formData,
        status: "Beklemede",
        createdAt: serverTimestamp()
      });
      toast.dismiss(loadingToast);
      toast.success('Randevu talebiniz alındı! 🎉');
      setTimeout(() => setIsSubmitted(true), 2000);
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error('Hata: ' + error.message);
    } finally {
      setIsUploading(false);
    }
  };

  if (isSubmitted) {
    return (
      <div className="apt-modern-page">
        <Toaster position="top-center" containerStyle={{ top: '50%', transform: 'translateY(-50%)' }} />
        <Navbar />
        <section className="success-container anim-in">
          <div className="success-card">
            <CheckCircle size={80} color="#2AB2AF" />
            <h2>Randevu Talebiniz Alındı!</h2>
            <p>Sayın <strong>{formData.fullName}</strong>, talebiniz iletildi.</p>
            <div className="success-details">
                <span>📅 {formData.date}</span>
                <span>⏰ {formData.time}</span>
                <span>💻 {formData.type}</span>
            </div>
            <button onClick={() => navigate('/')} className="home-btn">Ana Sayfaya Dön</button>
          </div>
        </section>
        <FooterSection />
      </div>
    );
  }

  return (
    <div className="apt-modern-page">
      <Toaster position="top-center" containerStyle={{ top: '50%', transform: 'translateY(-50%)' }} />
      <Navbar />
      
      <section className="apt-header">
        <div className="container">
          <h1>Hızlı Randevu <span>Planlayıcı</span></h1>
          <div className="step-indicator">
            {["Zaman", "İletişim"].map((s, i) => (
              <div key={i} className={`step-dot ${step > i ? 'active' : ''}`}>
                <div className="dot-circle">{step > i ? <CheckCircle size={16}/> : i + 1}</div>
                <span>{s}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="apt-main">
        <div className="container">
          <div className="apt-glass-card">
            
            {step === 1 && (
              <div className="apt-step anim-in">
                <h2>Muayene detaylarını seçin</h2>
                
                <div className="type-selector">
                  <label className="input-label"><Activity size={20}/> Randevu Türü</label>
                  <div className="type-grid">
                    <div className={`type-option ${formData.type === 'Yüz Yüze' ? 'active' : ''}`} onClick={() => setFormData({...formData, type: 'Yüz Yüze'})}>
                      <Building2 size={24} /><span>Yüz Yüze (Klinik)</span>
                    </div>
                    <div className={`type-option ${formData.type === 'Online' ? 'active' : ''}`} onClick={() => setFormData({...formData, type: 'Online'})}>
                      <Video size={24} /><span>Online Görüşme</span>
                    </div>
                  </div>
                </div>

                <div className="datetime-wrapper">
                  <div className="date-input-box">
                    <label className="input-label"><CalIcon size={20}/> Tarih Seçiniz</label>
                    <input type="date" value={formData.date} min={minDate} max={maxDate} onChange={handleDateChange} onKeyDown={(e) => e.preventDefault()} />
                  </div>
                  <div className="time-slots">
                    <label className="input-label"><Clock size={20}/> Uygun Saatler</label>
                    <div className="slots-grid">
                      {/* BURASI ARTIK DİNAMİK OLDU */}
                      {timeSlots.length > 0 ? (
                        timeSlots.map(t => (
                          <div key={t} className={`slot ${formData.time === t ? 'active' : ''}`} onClick={() => setFormData({...formData, time: t})}>{t}</div>
                        ))
                      ) : (
                        <p style={{ gridColumn: '1/-1', color: '#64748b', fontSize: '0.9rem' }}>Yükleniyor veya uygun saat bulunamadı...</p>
                      )}
                    </div>
                  </div>
                </div>
                <button className="next-btn" disabled={!formData.date || !formData.time} onClick={() => setStep(2)}>Sonraki Adım <ChevronRight /></button>
              </div>
            )}

            {step === 2 && (
              <div className="apt-step anim-in">
                <h2>Son bir dokunuş</h2>
                <form onSubmit={handleFinalSubmit} className="final-form">
                  <div className="input-premium">
                    <User size={20} /><input type="text" placeholder="Adınız Soyadınız" required value={formData.fullName} onChange={(e) => setFormData({...formData, fullName: e.target.value})} />
                  </div>
                  <div className="input-premium">
                    <Phone size={20} /><input type="tel" placeholder="05XXXXXXXXX" maxLength="11" required value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value.replace(/\D/g, '')})} />
                  </div>
                  <span className="note-label">Not / Şikayet (İsteğe bağlı)</span>
                  <div className="input-premium textarea-premium">
                    <MessageSquare size={20} style={{ marginTop: '8px', color: '#2AB2AF' }} /><textarea placeholder="Şikayetlerinizi yazabilirsiniz..." value={formData.note} onChange={(e) => setFormData({...formData, note: e.target.value})}></textarea>
                  </div>
                  <div className="summary-box">
                    <p><strong>Tür:</strong> {formData.type}</p>
                    <p><strong>Tarih:</strong> {formData.date} | <strong>Saat:</strong> {formData.time}</p>
                  </div>
                  <div className="btn-group">
                    <button type="button" className="back-btn" onClick={() => setStep(1)}>Geri</button>
                    <button type="submit" className="confirm-btn" disabled={isUploading}>
                      {isUploading ? <><Loader2 className="spinner" /> Kaydediliyor...</> : <>Randevuyu Tamamla <Send size={18}/></>}
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </section>
      <FooterSection />
    </div>
  );
};

export default AppointmentPage;